module.exports = __webpack_public_path__ + "img/scene4-2.98a03ad4.png";